import React, { useState } from "react";
import Box from "@mui/material/Box";
import SideBar from "../Side Bar/SideBar";
import MainAddressSection from "./MainAddressSection";
import Payment from "../../../My Payment/Components/Payment/Payment";
import Promotion from "../../../Promotions/Promotion";
import TrackOrder from "../../../../Pages/TrackOrder/TrackOrder";
import GiftCard from "../../../gift_card/GiftCard";
import CustomTab from "../../../MyActivityComponents/CustomTabs"
import SaveAddressSection from "../../../../Pages/SaveAddress/SaveAddress";
import Favourite from "../../../Favourite/Favourite";
import MyProfileFormSection from "../../../../Pages/MyProfile/MyProfileFormSection";

function MainSideBar() {
  const [currentPage, setCurrentPage] = useState("my-profile");
  return (
    <>
      <Box sx={{ display: "flex", height: "90vh" }} maxWidth>
        <Box
          className="sideBar"
          sx={{
            width: { lg: "15%" },
            borderRight: "1px solid #E1E1E6",
            hegiht: "auto",
          }}
        >
          <SideBar
            handleOnClick={(e) => {
              setCurrentPage(e);
            }}
            currentPage={currentPage}
          />
        </Box>
          {currentPage === "my-profile" ? (
            <MyProfileFormSection />
          ) : currentPage === "my-payment" ? (
            <Payment />
          ) : currentPage === "promotions" ? (
            <Promotion />
          ) : currentPage === "track-order" ? (
            <TrackOrder />
          ) : currentPage === "gift-card" ? (
            <GiftCard />
          ) : currentPage === "my-activity" ? (
            <CustomTab />
          ) : currentPage === "saved-address" ? (
            <MainAddressSection />
          ) : currentPage === "favroit" ? (
            <Favourite />
          ) : null}
        </Box>

   
    </>
  );
}

export default MainSideBar;
